import { render, staticRenderFns } from "./PromotionBarcode.vue?vue&type=template&id=3b719a46"
import script from "./PromotionBarcode.vue?vue&type=script&lang=js"
export * from "./PromotionBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports